export function formatCountdown(targetIso) {
  if (!targetIso) return null;
  const target = new Date(targetIso).getTime();
  const diffMs = Math.max(0, target - Date.now());
  const totalMinutes = Math.floor(diffMs / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return { hours, minutes };
}

export function formatLocalReset(targetIso) {
  if (!targetIso) return null;
  return new Date(targetIso).toLocaleString(undefined, {
    weekday: "short",
    hour: "numeric",
    minute: "2-digit",
  });
}
